import PageTemplate, { PageData } from "../../components/feature/sections/PageTemplate";
import { SERVICES } from "../../mocks/siteData";

const whyChooseImage = "https://public.readdy.ai/ai/img_res/ee7f1ac0086420e397eed8ecd1a245a6.jpg";

const servicesData: PageData = {
  hero: {
    eyebrow: "The Lash Bar — Lehi, Utah",
    headline: "Every Service, Flawlessly Executed",
    subheadline:
      "From precision lash artistry voted best in Utah to expert hair color and luxury tanning — every service at The Lash Bar is a premium, personalized experience built for you.",
    primaryCTA: {
      label: "Reserve Your Appointment",
      href: "https://dashboard.boulevard.io/booking/businesses/1dc117c9-31f1-49a3-9094-6719fd2f14a0/widget#/cart/menu",
      external: true,
    },
    secondaryCTA: { label: "Our Location", href: "/location" },
    bgImage:
      "https://readdy.ai/api/search-image?query=dramatic%20overhead%20close-up%20of%20professional%20lash%20artist%20applying%20eyelash%20extensions%20to%20client%20lying%20on%20treatment%20table%2C%20precision%20artisan%20work%20clearly%20visible%2C%20luxury%20beauty%20studio%20with%20white%20and%20neutral%20tones%2C%20warm%20professional%20lighting%2C%20ultra%20sharp%20editorial%20beauty%20photography%2C%20high-end%20masterful%20craftsmanship&width=1920&height=1080&seq=hero-services-v3-overhead&orientation=landscape",
  },

  services: {
    eyebrow: "Complete Service Menu",
    headline: "Services Crafted for You",
    subheadline:
      "Each service at The Lash Bar is delivered by certified professionals using premium products — completely customized for your individual goals and natural features.",
    items: SERVICES,
  },

  aiBlock: {
    eyebrow: "What We Offer",
    headline: "Service Excellence, Defined",
    description:
      "At The Lash Bar in Lehi, UT, every service is crafted to exceed the highest expectations. Our certified lash artists, professional hair stylists, and tanning specialists use premium products and personalized techniques to deliver luxury-level results — consistently and beautifully.",
    whatWeDo: [
      {
        title: "Classic, Volume & Hybrid Lash Extensions",
        text: "Applied one-by-one by certified VIP and Diamond Lash Artists, each set is custom-designed for your eye shape and aesthetic goals. Classic, volume, and hybrid styles available. Results last 2 to 4 weeks with proper aftercare and recommended fill schedule.",
      },
      {
        title: "Lash Lift & Tint",
        text: "A semi-permanent treatment that lifts, curls, and darkens your natural lashes — no extensions required. Ideal for clients wanting effortless, low-maintenance beauty. Results last 6 to 8 weeks with excellent retention and minimal upkeep required.",
      },
      {
        title: "Hair Color & Precision Styling",
        text: "Full color, balayage, highlights, precision cuts, blowouts, and wedding updos using Kérastase professional products. Men's and children's cuts also available. All color services begin with a consultation to ensure we achieve your ideal, personalized result.",
      },
      {
        title: "Airbrush, UV & Infrared Tanning",
        text: "Professional airbrush tanning for a streak-free, natural-looking glow. High-end UV tanning beds and infrared pod wellness sessions also available. Every service is tailored to your skin tone and desired result for a flawless, customized finish.",
      },
    ],
    benefits: [
      { title: "Premium Products Exclusively", text: "Kérastase, RVCA, Mangiacotti — only the finest brands in our studio." },
      { title: "Certified at Every Level", text: "VIP and Diamond-certified lash artists. Every team member fully trained." },
      { title: "Consultation Included", text: "Every appointment begins with a personalized consultation — no guesswork." },
      { title: "Full Aftercare Support", text: "Comprehensive aftercare guidance after every lash and tanning service." },
    ],
  },

  process: {
    eyebrow: "Your Service Experience",
    headline: "From Booking to Beautiful",
    steps: [
      {
        number: "01",
        title: "Consultation",
        description: "Share your vision. Your artist evaluates your natural features, discusses style options, and creates a completely personalized service plan designed exactly for you.",
        icon: "ri-user-voice-line",
      },
      {
        number: "02",
        title: "Custom Lash Design",
        description: "Your artist maps your custom look — selecting precise lengths, curls, and techniques that enhance your natural beauty and align perfectly with your lifestyle.",
        icon: "ri-edit-line",
      },
      {
        number: "03",
        title: "Precision Application",
        description: "Relax in our luxury studio as your artist works with precision using only premium professional-grade products. Meticulous technique, flawless every single time.",
        icon: "ri-sparkling-2-line",
      },
      {
        number: "04",
        title: "Aftercare Guidance",
        description: "Walk out transformed. Full aftercare guidance included — maintaining your results at home is simple with expert advice from your dedicated Lash Bar artist.",
        icon: "ri-heart-3-line",
      },
    ],
  },

  whyChoose: {
    eyebrow: "The Lash Bar Standard",
    headline: "Why Clients Choose Lash Bar Utah",
    items: [
      {
        icon: "ri-verified-badge-line",
        title: "VIP & Diamond Certified Artists",
        description: "Our artists hold the highest certification tiers in the industry — every technique mastered before working with clients. The Lash Bar standard is genuinely non-negotiable.",
      },
      {
        icon: "ri-shield-check-line",
        title: "Strict Hygiene Protocols",
        description: "Sterilized tools, single-use applicators, and premium medical-grade adhesives. Hygiene is not optional at The Lash Bar — it's the uncompromising foundation of every service.",
      },
      {
        icon: "ri-gem-line",
        title: "Premium Materials, Always",
        description: "Professional-grade lash fibers, Kérastase hair products, and premium tanning solutions. Every product is selected for safety, quality, and genuinely luxury-level results.",
      },
      {
        icon: "ri-time-line",
        title: "Efficient & Deeply Relaxing",
        description: "We respect your time — precise, efficient appointments without sacrificing quality. Our studio is designed as a sanctuary where you truly unwind while we work.",
      },
    ],
    image: whyChooseImage,
  },

  serviceAreas: {
    eyebrow: "Serving the Wasatch Front",
    headline: "Serving Lehi, Utah and Surrounding Areas",
    description:
      "Our Lehi studio is the go-to destination for premium lash extensions, hair, and tanning across Utah County and the greater Salt Lake City metro area — centrally located for your convenience.",
  },

  testimonials: {
    eyebrow: "Client Experiences",
    headline: "Loved by Utah Clients",
  },

  faq: {
    eyebrow: "Service FAQ",
    headline: "Service Questions Answered",
    items: [
      {
        question: "How should I prepare for my lash extension appointment?",
        answer:
          "Arrive with completely clean, makeup-free lashes and avoid caffeine beforehand as it can cause lash movement during application. Remove contact lenses if possible and wear comfortable clothing. Full sets take approximately 90 to 120 minutes — plan your schedule accordingly for the best possible experience.",
      },
      {
        question: "How long does a full lash extension appointment take?",
        answer:
          "A classic full set typically takes 90 to 120 minutes. Volume sets can take up to two and a half hours for a full, dramatic look. Fill appointments usually run 60 to 90 minutes depending on your natural lash retention and how much time has passed since your previous visit.",
      },
      {
        question: "What hair color and styling services do you offer?",
        answer:
          "We offer full color, highlights, balayage, toning, and color corrections using Kérastase professional products. Precision cuts, blowouts, wedding updos, and everyday styling are also available. All color services include a personal consultation to ensure we achieve your exact desired result.",
      },
      {
        question: "How long does a professional airbrush tan last?",
        answer:
          "Airbrush tans typically last 7 to 10 days with proper aftercare. Avoid water for the first 8 hours after application and exfoliate thoroughly before your appointment for the most even, natural-looking glow. We customize every shade to your unique skin tone for flawless, personalized results.",
      },
      {
        question: "Can I book lashes and tanning in the same visit?",
        answer:
          "Absolutely — many clients combine services in a single convenient visit. Simply note the combination when booking so we can efficiently schedule both services. We coordinate everything to ensure your experience flows seamlessly and comfortably from start to finish.",
      },
      {
        question: "Do you offer services for clients with sensitive eyes or skin?",
        answer:
          "Yes, we do. We use premium low-irritant lash adhesives and can perform a patch test before your appointment if you have known sensitivities. Simply mention this when booking so your artist can prepare the ideal products and protocol to ensure your complete comfort and safety.",
      },
    ],
  },

  finalCTA: {
    eyebrow: "Begin Your Experience",
    headline: "Book Your Service Today",
    subtext:
      "Serving Lehi, Salt Lake City, American Fork, Pleasant Grove, Orem, and all of Utah County. Step into The Lash Bar and leave looking and feeling truly extraordinary.",
  },
};

export default function ServicesPage() {
  return <PageTemplate data={servicesData} />;
}
